import { render, staticRenderFns } from "./index - 副本.vue?vue&type=template&id=06b146dc&scoped=true"
import script from "./index - 副本.vue?vue&type=script&lang=js"
export * from "./index - 副本.vue?vue&type=script&lang=js"
import style0 from "./index - 副本.vue?vue&type=style&index=0&id=06b146dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b146dc",
  null
  
)

export default component.exports